import { createEnv } from '@t3-oss/env-nextjs'
import { z } from 'zod'

export const isBuild =
	process.env.CI === '1' ||
	process.env.CI === 'true' ||
	process.env.SKIP_ENV_VALIDATION === '1' ||
	process.env.SKIP_ENV_VALIDATION === 'true'

export const env = createEnv({
	/**
	 * Server-side environment variables.
	 * These are not accessible on the client.
	 */
	server: {
		APP_HOST: z.string(),
		// Database
		DATABASE_URL: z.string().url(),
		DATABASE_URL_DIRECT: z.string().url(),

		// App Secrets
		PAYLOAD_SECRET: z.string().min(1),
		PAYLOAD_CORS: z
			.string()
			// Allow '*' as a special case, otherwise transform CSV to array
			.transform((str) => (str === '*' ? '*' : str.split(',')))
			// 3. Clean up whitespace and empty strings
			.pipe(z.union([z.literal('*'), z.array(z.string().trim().min(1))])),
		PAYLOAD_CSRF: z
			.string()
			.transform((str) => str.split(','))
			.pipe(z.array(z.string().trim().url())),
		REVALIDATE_TOKEN: z.string().min(1),
		TURNSTILE_SECRET_KEY: z.string().min(1),

		// S3 Settings
		S3_ENDPOINT: z.string().url(),
		S3_REGION: z.string().min(1),
		S3_ACCESS_KEY_ID: z.string().min(1),
		S3_SECRET_ACCESS_KEY: z.string().min(1),
		S3_BUCKET: z.string().min(1),
		S3_PUBLIC_DOMAIN: z.string(),

		// Admin
		ADMIN_EMAIL: z
			.string()
			.transform((str) => str.split(','))
			.pipe(z.array(z.string().trim().email())),
		ADMIN_PASSWORD: z.string().min(1),

		// Mailjet Config
		MAIL_HOST: z.string().min(1),
		MAIL_PORT: z.coerce.number(), // Automatically converts string "51006" to number
		// These are optional because they were empty in your .env file
		MAIL_USER: z.string().optional(),
		MAIL_PASS: z.string().optional(),
		MAIL_SENDER_EMAIL: z.string().email(),
		MAIL_SENDER_NAME: z.string().min(1),
	},

	/**
	 * Client-side environment variables.
	 * These are exposed to the client (must be prefixed with NEXT_PUBLIC_).
	 */
	client: {
		NEXT_PUBLIC_API_HOST: z.string(),
		NEXT_PUBLIC_GA_MEASUREMENT_ID: z.string().optional(),
		NEXT_PUBLIC_TURNSTILE_SITE_KEY: z.string().min(1),
	},

	/**
	 * Runtime Environment Mapping.
	 * You must explicitly map the schema keys to the process.env values.
	 */
	runtimeEnv: {
		ADMIN_EMAIL: process.env.ADMIN_EMAIL,
		ADMIN_PASSWORD: process.env.ADMIN_PASSWORD,
		DATABASE_URL_DIRECT: process.env.DATABASE_URL_DIRECT,
		DATABASE_URL: process.env.DATABASE_URL,
		MAIL_HOST: process.env.MAIL_HOST,
		MAIL_PASS: process.env.MAIL_PASS,
		MAIL_PORT: process.env.MAIL_PORT,
		MAIL_SENDER_EMAIL: process.env.MAIL_SENDER_EMAIL,
		MAIL_SENDER_NAME: process.env.MAIL_SENDER_NAME,
		MAIL_USER: process.env.MAIL_USER,
		NEXT_PUBLIC_API_HOST: process.env.NEXT_PUBLIC_API_HOST,
		NEXT_PUBLIC_GA_MEASUREMENT_ID: process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID,
		APP_HOST: process.env.APP_HOST,
		NEXT_PUBLIC_TURNSTILE_SITE_KEY: process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY,
		PAYLOAD_SECRET: process.env.PAYLOAD_SECRET,
		REVALIDATE_TOKEN: process.env.REVALIDATE_TOKEN,
		S3_ACCESS_KEY_ID: process.env.S3_ACCESS_KEY_ID,
		S3_BUCKET: process.env.S3_BUCKET,
		S3_ENDPOINT: process.env.S3_ENDPOINT,
		S3_PUBLIC_DOMAIN: process.env.S3_PUBLIC_DOMAIN,
		S3_REGION: process.env.S3_REGION,
		S3_SECRET_ACCESS_KEY: process.env.S3_SECRET_ACCESS_KEY,
		TURNSTILE_SECRET_KEY: process.env.TURNSTILE_SECRET_KEY,
		PAYLOAD_CORS: process.env.PAYLOAD_CORS,
		PAYLOAD_CSRF: process.env.PAYLOAD_CSRF,
	},
	skipValidation: isBuild,
	emptyStringAsUndefined: true,
})
